/**************************************************
 * Nombre:       Nosotros_Portada
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import fondo from '../../../Recursos/port_nosotros.png'
import {NEGRITA} from "../../../Constantes";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";

const Nosotros_Portada = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                marginTop: 0,
                background: `linear-gradient(0deg, #000 1%, rgba(0, 0, 0, 0.00) 43.66%, rgba(0, 0, 0, 0.00) 74.72%, rgba(0, 0, 0, 0.90) 100%), url(${fondo})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center',
            }}
        >

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-end'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, color: 'white', height: sCell ? 480 : 650}}
            >


                <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Typography sx={{fontFamily: NEGRITA, fontSize: sCell ? 30 : 52}}>Nosotros</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mb:  sCell ? 3 : 8}}>
                            <Typography sx={{fontSize: sCell ? 16 : 18,lineHeight: sCell ? 1.2 : 1.3}}>
                                Quesuditas es una empresa con trayectoria, organizada en sus procesos y guiada por un
                                fuerte sentido humano. Cada detalle refleja nuestro compromiso con la calidad, la
                                calidez y el amor por lo que hacemos.
                            </Typography>
                        </Grid>

                    </Grid>
                </Grid>


            </Grid>

        </Grid>
    )

}
export default Nosotros_Portada